<template>
    <div>
        <ds-header title="地点管理"></ds-header>
        <a-form layout="inline">
            <a-form-item label="地点名称：">
                <a-input v-model.trim="searchForm.name" placeholder="请输入地点名称" class="inputClass" style="min-width: 200px;" />
            </a-form-item>
            <a-form-item label="地点类型：">
                <a-select v-model="searchForm.placeType" placeholder="请选择地点类型" style="min-width: 200px;">
                    <a-select-option v-for="it in locationAllTypeOpts" :key="it.value+it.label" :value="it.value">{{it.label}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="所属项目：">
                <a-select v-model="searchForm.projectIdList" mode="multiple" :maxTagCount="2" placeholder="全部" style="min-width: 200px;">
                    <a-select-option v-for="it in projectOpts" :key="it.projectId+it.projectName" :value="it.projectId">{{it.projectName}}</a-select-option>
                </a-select>
            </a-form-item>
            <div class="btn-group">
                <a-button type="primary" @click="()=>pageChange({current: 1, pageSize: 10})">查询</a-button>
                <a-button @click="resetSearchForm">重置</a-button>
            </div>
        </a-form>
        <div style="margin-top: 10px;">
            <a-button type="primary" @click="showEditAreaModel()"> 新增地点 </a-button>
        </div>
        <a-table @change="pageChange" :columns="columns" style="margin-top: 10px"
            :pagination="pagination.total ? pagination : false" :data-source="tableData" :rowKey="(record) => record.id"
            bordered :scroll="{ x: 3200 }">
            <span slot="project_name_list" slot-scope="text, record" class="action">
                <a-tooltip>
                    <template slot="title">
                        {{ record.project_name_list }}
                    </template>
                    <span class="field">{{ record.project_name_list }}</span>
                </a-tooltip>
            </span>
            <span slot="action" slot-scope="text, record" class="action">
                <a-button type="link" @click="showEditAreaModel(record)" size="small"> 编辑 </a-button>
                <a-button type="link" style="color: #ff4d4f;" @click="deleteStaff(record)" size="small"> 删除 </a-button>
            </span>
        </a-table>
        <!-- 新增弹窗 -->
        <a-modal :maskClosable="false" :rules="addAreaFormRules" :title="title" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
            <a-form-model ref="ruleForm" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :rules="rules">
                <a-form-model-item label="地点名称" prop="name">
                    <a-input v-model.trim="form.name" placeholder="请输入地点名称，内容不超过20个字" :maxLength="20" />
                </a-form-model-item>
                <a-form-model-item label="所属项目" prop="projectId">
                    <a-select v-model="form.projectId" placeholder="请选择所属项目" :disabled="editStatus">
                        <a-select-option v-for="item in projectMsgList" :key="item.projectId" :value="item.projectId">
                            {{ item.projectName }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="地点类型" prop="placeType">
                    <a-radio-group v-model="form.placeType" :disabled="editStatus">
                        <a-radio v-for="it in locationTypeOpts" :key="it.value" :value="it.value">{{ it.label }}</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
<script>
const defaultSearchForm = {
    name: '',
    placeType: '',
    projectIdList: []
}
const defaultLocaltions = [
    { value: 1, label: '物业服务地点' },
    { value: 2, label: '工单归档区域' },
];
import * as  api from '@/api/demandPool';
import { columns } from './index';
import { paramFactory } from '@/utils/utils';
import _ from 'lodash';
export default {
    data() {
        return {
            searchForm: Object.assign({}, defaultSearchForm),
            locationTypeOpts: defaultLocaltions,
            localtionTypeMaps: _.fromPairs(_.map(defaultLocaltions, item => [item.value, item.label])),
            locationAllTypeOpts: [],
            projectOpts: [],
            visible: false,
            confirmLoading: false,
            columns,
            tableData: [],
            title: '',
            pagination: {
                showSizeChanger: true,
                current: 1,
                pageSize: 10,
                total: 0,
                showQuickJumper: true,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            },
            form: {
                projectId: undefined,
                name: '',
                placeType: undefined,
            },
            addAreaFormRules: {
                name: [{ required: true, message: '请输入地点名称', trigger: 'blur' }],
                projectId: [{ required: true, message: '请选择所属项目', trigger: 'change' }],
                placeType: [{ required: true, message: '请选择地点类型', trigger: 'change' }],
            },
            placeId: '',
            projectMsgList: [],
            rules: {
                name: [{ required: true, message: '请输入地点名称', trigger: 'blur' }],
                projectId: [{ required: true, message: '请选择所属项目', trigger: 'blur' }],
                placeType: [{ required: true, message: '请选择地点类型', trigger: 'blur' }],
            },
            editStatus: false, // 编辑状态, 如果是true的时候, 弹窗地点类型要禁用, 反之启用
        }
    },
    created() {
        this.getPlaceTypeType();
        this.getTableList();
        this.getProject();
    },
    methods: {
        resetSearchForm(){
            this.searchForm = Object.assign({}, defaultSearchForm);
            this.getTableList();
        },
        getPlaceTypeType(){
            return new Promise((res, rej)=>{
                res({
                    code: 200, 
                    data: this.locationTypeOpts, 
                    msg: ''
                });
            })
            .then(({code, data, msg}) => {
                if(code == '200') {
                  debugger;
                    // this.locationTypeOpts = data;
                    this.locationAllTypeOpts = [{label: '全部', value: ''}].concat(data);
                } else {
                    this.$message.error(msg);
                }
            })
        },
        handleCancel() {
            Object.assign(this.form, {
                projectId: '',
                name: '',
                placeType: undefined,
            });
            this.$refs.ruleForm.resetFields();
            this.visible = false;
        },
        pageChange(option) {
            this.pagination.current = option.current;
            this.pagination.pageSize = option.pageSize;
            this.getTableList();
        },
        async handleOk() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    let res = ''
                    console.log(this.placeId);
                    if (this.placeId) {
                        res = await api.placeUpdate({ ...this.form, placeId: this.placeId })
                    } else {
                        res = await api.placeAdd(this.form);
                    }

                    if (res.code === '200') {
                        this.$message.success(res.msg);
                        this.handleCancel()
                        this.getTableList();
                    } else {
                        this.$message.error(res.msg);
                    }
                }
            });
        },
        getTableList() {
            // name是必传
            const mixinConf = {size: this.pagination.pageSize, page: this.pagination.current};
            const params = paramFactory(this.searchForm, ["placeType", "projectIdList"], [], mixinConf);
            return api.placeList(params)
            .then(res => {
                console.log(res);
                this.tableData = res.data.list.map((it)=>{
                    it["placeTypeName"] = this.localtionTypeMaps[it.placeType];
                    return it;
                });
                this.pagination.total = res.data.total
            })
        },
        showEditAreaModel(record) {
            this.visible = true; 
            this.title = record ? '编辑地点' : '新增地点';
            this.placeId = record ? record.placeId : "";
            if(record){
                this.$set(this, "form", {
                    projectId: record.projectId,
                    name: record.name,
                    placeType: record.placeType,
                });
                this.editStatus = true;
            }else{
                this.$set(this, "form", {
                    projectId: '',
                    name: '',
                    placeType: undefined,
                });
                this.editStatus = false;
            }
        },
        // 删除地点
        deleteStaff(item) {
            const self = this;
            this.$confirm({
                title: '确认删除地点',
                content: '删除后此数据将无法恢复, 确定要删除吗',
                onOk() {
                    self.placeDeleted(item.placeId);
                },
                onCancel() { },
            });
        },
        async placeDeleted(placeId) {
            let res = await api.placeDeleted(placeId)
            if (res.code === '200') {
                this.$message.success(res.msg);
                this.handleCancel()
                this.getTableList();
            } else {
                this.$message.error(res.msg);
            }
        },
        //获取项目信息
        async getProject() {
            const res = await api.requirementProject2();
            if (res.code == 200) {
                this.projectMsgList = res.data;
                this.projectMsgList.push({
                    projectId: "社区用户",
                    projectName: "社区用户"
                });
                // this.projectOpts = [{projectId: "", projectName: "全部"}].concat(this.projectMsgList)
                this.projectOpts = this.projectMsgList;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.btn-group{
    margin-top: 5px;
    display: inline-block;
    button{
        margin: 0 5px;
    }
}
</style>